import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import Feedback from './Feedback';
import Loading from './Loading';
import {ajaxScrollFilter, setSelectedFeedback} from './redux/FeedbackRedux';
import * as uuid from 'uuid';

class FeedbackList extends React.Component {

    constructor() {
        super();
        this.state = {width: null, height: null, element_id: uuid.v4()};
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    handleScroll(event) {
        if (jQuery(event.target).scrollTop() + jQuery(event.target).innerHeight() >= event.target.scrollHeight - 100) {
            const timeframe = this.props.state.timeframe;
            const status = this.props.state.status;
            const fid = this.props.state.feedback_detail.feedback_id;
            if (this.props.state.next_cursor) {
                if (!this.props.state.businesses) {
                    const bid = this.props.state.business.business_id;
                    if (this.props.state.loading === false) {
                        this.props.dispatch(ajaxScrollFilter(timeframe, status, fid, bid, null, this.props.state.next_cursor, this.props.state.query, this.props.state.other_filter, this.props.state.archive, this.props.state.department_ids ?? null));
                    }
                } else {
                    const ids = [];
                    for (const i in this.props.state.businesses) {
                        ids.push(this.props.state.businesses[i].business_id);
                    }
                    if (this.props.state.loading === false) {
                        this.props.dispatch(ajaxScrollFilter(timeframe, status, fid, ids, null, this.props.state.next_cursor, this.props.state.query, this.props.state.other_filter, this.props.state.archive, this.props.state.department_ids ?? null));

                    }
                }
            }
        }
    }

    render() {
        let items = [];
        this.props.state.initial_feedbacks.map((value, index) => {
            items.push(<Feedback key={index} feedback={value} id={value.feedback_id}
                                 red_alerts_list={this.props.state.red_alerts_list}/>);
        });

        return (
            <div className="col-12 col-lg-4 feedback-list scroll" id={this.state.element_id}>
                <div className="scroll-contents" onScroll={this.handleScroll.bind(this)}
                     style={{"width": (this.state.width > 0 ? this.state.width + "px" : "100%")}}>
                    <Loading location={'search'}/>
                    {items}
                    <div className="col-sm-12 pt-3 pb-3 text-center">
                        <Loading location={'list'}/>
                    </div>
                </div>
            </div>
        );
    }

    updateDimensions() {
        let element = document.getElementById(this.state.element_id);
        let elementWidth = parseFloat(element.clientWidth);
        let cs = getComputedStyle(element);
        let new_width = elementWidth;

        this.setState({width: new_width});
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(FeedbackList)
